import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="row-materials-search"
export default class extends Controller {
  static targets = ["select", "form", "searchForm", "input"]
  connect() {
    console.log("ProductsSearchController connected");
    console.log(this.selectTargets);
      new TomSelect("#category_product_id",{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
      });
      setTimeout(() => {
        document.getElementById("category_product_id").tomselect.close() 
      }, 100);
  }

  submit(e) {
    this.inputTarget.value = '';
   this.formTarget.requestSubmit(); 
  }

  submitSearch(e) {
    this.searchFormTarget.requestSubmit()
  }
}
